<template>
  <tr @click="editDialog = true">
    <td
      v-for="(header, i) in headers"
      :key="i"
      :class="`text-xs-${header.align}`"
    >{{row[header.value]}}</td>
    <v-dialog v-model="editDialog" lazy v-if="userAuthClass">
      <!-- <edit-component v-bind="{[parent]: row }" @close="editDialog = false"></edit-component> -->
      <edit-component
        :is="dynamicComponent"
        v-bind="{[parent.toLowerCase()]: row }"
        @close="editDialog = false"
      ></edit-component>
    </v-dialog>
  </tr>
</template>

<script>
export default {
  data() {
    return {
      editDialog: false,
      editProp: this.parent.toLowerCase()
    };
  },
  props: {
    row: Object,
    headers: Array,
    parent: String
  },
  computed: {
    dynamicComponent() {
      return () =>
        import(
          "@/components/" + this.parent.toLowerCase() + "s/edit" + this.parent
        );
    }
  }
};
</script>

<style>
</style>
